var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBox',{attrs:{"tag":_vm.tag}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")],{"formattedDate":_vm.formattedDate})],2)}
var staticRenderFns = []

export { render, staticRenderFns }